import { Dialog, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight, X } from "react-feather";
import styles from "../shop.module.css";

// Full-size photo viewer for an item, with previous / next (arrow keys work too)
const ImageLightbox = ({ images, index, onChange, onClose, title }) => {
  const open = index !== null && index !== undefined && images.length > 0;
  const go = (step) => onChange((index + step + images.length) % images.length);

  return (<Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    PaperProps={{ className: styles.Lightbox }}
    onKeyDown={(e) => {
      if (images.length < 2) return;
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
    }}
  >
    {open && <>
      <IconButton className={styles.LightboxClose} onClick={onClose} aria-label="Close"><X size={22} /></IconButton>
      {images.length > 1 && <IconButton className={`${styles.LightboxNav} ${styles.LightboxPrev}`} onClick={() => go(-1)} aria-label="Previous photo"><ChevronLeft size={26} /></IconButton>}
      <img src={images[index]} alt={title || ""} className={styles.LightboxImage} />
      {images.length > 1 && <IconButton className={`${styles.LightboxNav} ${styles.LightboxNext}`} onClick={() => go(1)} aria-label="Next photo"><ChevronRight size={26} /></IconButton>}
      {images.length > 1 && <span className={styles.LightboxCount}>{index + 1} / {images.length}</span>}
    </>}
  </Dialog>);
};

export default ImageLightbox;
